<button mat-button disabled [class]="colorClass">
  <mat-icon [matTooltip]="api" class="model-type material-icons-outlined">
    {{ modelIcon }}
  </mat-icon>
  <span class="title">{{ api }}</span>
</button>
